import type { RequestPayload } from "@inertiajs/core";
import { usePage } from "@inertiajs/react";
import { Divider, Fieldset, Stack } from "@mantine/core";
import { useForm } from "@mantine/form";
import type { Coach } from "../../models/coach";
import { SaveButton } from "../button/SaveButton";
import { ParticularsForm, type ParticularsFormErrorType, type ParticularsFormType } from "../particularsForm/ParticularsForm";
import { UserForm, type UserFormErrorTypes, type UserFormType } from "../user/UserForm";

type CoachFormProps = {
  coach?: Coach;
  submitButtonLabel: string;
  onSubmit: (values: RequestPayload) => void;
};

type CoachFormType = UserFormType & ParticularsFormType;

type FormErrors = UserFormErrorTypes & ParticularsFormErrorType;

export function CoachForm({ coach, onSubmit, submitButtonLabel }: CoachFormProps) {
  const { errors } = usePage<{ errors: FormErrors }>().props;

  const form = useForm<CoachFormType>({
    mode: "uncontrolled",
    initialValues: {
      salutation: coach?.salutation,
      first_name: coach?.first_name,
      last_name: coach?.last_name,
      user_attributes: {
        email: coach?.user.email,
        password: "",
        active: coach?.user.active ?? true,
      },
    },
  });

  return (
    <form onSubmit={form.onSubmit((values) => onSubmit(values))}>
      <Fieldset legend="Details">
        <Stack maw="60rem">
          <ParticularsForm form={form} errors={errors} />
          <UserForm form={form} errors={errors} />
          <Divider />
          <SaveButton label={submitButtonLabel} />
        </Stack>
      </Fieldset>
    </form>
  );
}
